import FlussiListPage from "./pages/FlussiListPage.vue";
import FlussiViewPage from "./pages/FlussiViewPage.vue";
import FlussiFatturaAnticipataListPage from "./pages/FlussiFatturaAnticipataListPage.vue";

export default {
    FlussiListPage,
    FlussiViewPage,
    FlussiFatturaAnticipataListPage,
};
